import { motion } from 'framer-motion';
import Image from 'next/image';
import { Service } from '@/types/service.types';
import { cn } from '@/utils/utils';
import { LucideIcon } from 'lucide-react';

interface ServiceCardContentProps {
	service: Service;
	index: number;
	order: number;
}

export function ServiceCardContent({ service, index, order }: ServiceCardContentProps) {
	const IconComponent = service.icon as LucideIcon;
	
	return (
		<motion.div
			className={cn(
				'flex flex-col space-y-6 lg:max-w-xl mx-auto',
				`lg:order-${order}`
			)}
			initial={{ opacity: 0, y: 20 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, margin: '-100px' }}
			transition={{
				duration: 0.5,
				ease: [0.2, 0.65, 0.3, 0.9],
				delay: index * 0.1,
			}}
		>
			<div className="w-14 h-14 bg-primary/10 rounded-2xl flex items-center justify-center">
				<IconComponent className="w-7 h-7 text-red-500" />
			</div>

			{service.image && (
				<div className="relative aspect-video w-full rounded-xl overflow-hidden shadow-lg">
					<Image
						src={service.image}
						alt={service.title}
						fill
						className="object-cover"
						sizes="(max-width: 768px) 90vw, (max-width: 1200px) 35vw, 450px"
						priority={index === 0}
					/>
				</div>
			)}

			<div className="space-y-4">
				<h2 className="text-3xl font-bold font-space-grotesk">{service.title}</h2>
				<p className="text-lg text-muted-foreground">{service.description}</p>
			</div>
		</motion.div>
	);
}
